<script>
import checkout from '@/modules/mixins/checkout'
import AllowanceBudgetProgressbar from '@/components/molecules/AllowanceBudgetProgressbar.vue'
import Recommendation from '@/components/molecules/Recommendation.vue'
import Recommender from '@/components/organism/Recommender.vue'
import allowanceBudget from '@/modules/mixins/allowanceBudget'

export default {
    name: 'Page',
    components: { Recommender, Recommendation, AllowanceBudgetProgressbar },

    mixins: [checkout, allowanceBudget],
}
</script>

<template lang="pug">
.checkout-page.container-fluid.container-lg.pt-page 
    transition(name="fade" mode="out-in")
        .row.mb-6(v-if="loaded")
            .col-12.col-md-8
                .d-flex.align-items-center.justify-content-between.mb-3.flex-wrap
                    h1.felx-inline.mb-0 {{restaurant.name}}
                    router-link.btn.btn-secondary.btn-pill.btn-sm.ml-auto(:to="{name: 'restaurant', params: {slug: restaurant.slug}}" id="no_items")
                        | {{$t('order.back_store')}}
                checkout-authentication.mb-6(@authenticated="openCanteenAddressModal(false)" id="authentication")
                template(v-if="isLoggedIn")
                    delivery-details-block.mb-6(id="unsaved_address" :loading="loading || stillLoading" :unavailable-addresses="unavailableAddresses")
                    checkout-payment.mb-6(ref="checkoutPayment" :value="validInvoiceInfo" @input="setInvoiceInfoValidity" id="payment_method" :stripe="stripe")
                    checkout-error-block(
                        :order-errors="orderErrors"
                        :possible-errors="possibleErrors"
                        :calculation-errors="calculationErrors"
                        :stripe="stripe")
                    modal-canteen-address(ref="ModalCanteenAddress" @saved="placeOrder")
                    recommender(card)
                        template(v-slot:title)
                            h2 {{ hasBudget ? $t('order.allowance_budget_progressbar.recommendations_title') : $t('cart.recommendation') }}
                                span.text-danger.h2.ml-2(v-if="hasBudget") {{ remainBudget | toCurrency(currency.locale, currency.currency_code) }}
                    transition-group.position-relative.checkout-button(name="fade-absolute" tag="div")
                        .total-pay.d-none(key="total") {{ $t('total_to_pay') }}: {{ cart.calculation.price_sum_user | toCurrency(currency.locale, currency.currency_code) }}
                        allowance-budget-progressbar(v-if="hasBudget").mb-6(key="remainBudget" v-model="remainBudget")
                        #payment-request-button.transition-opacity(v-show="stripe.selectedOnlinePayment" :class="{'pointer-none opacity-50': orderDisabled}" key="onlinePayment")
                        button-loader.btn.btn-primary.btn-md.btn-block.btn-place-order(
                            v-if="!stripe.selectedOnlinePayment"
                            key="payment"
                            @click="startOrderingProcess"
                            :class="{'disabled': orderDisabled || stillLoading, 'highlight': stillLoading}"
                            :loading="loading"
                            inline)
                                template(v-if="stillLoading")  {{ $t('base.still_loading') }}
                                template(v-else) {{ $t('cart.place_order') }}

            .col-12.col-md-4
                cart-block(:restaurant="restaurant" id="minimum_value")
        template(v-else)
            spinner.mx-auto.mt-12.d-block(v-if="pageLoading")
            h1.mt-12.text-center(v-else) Error!     
    modal-delivery-state-change
    select-meal(:details="meal" )
    modal-vat-prompt(ref="ModalVatPrompt" @no="onVatNo" @yes="onVatYes")
    modal-confirm(
        v-model="confirmCardPayment"
        header-level="h1"
        :header-label="$t('order.card_payment_confirm.title', {total: $options.filters.toCurrency(cart.calculation.price_sum_user, currency.locale, currency.currency_code )})"
        :body-label="nextAvailableAllowanceToday ? $t('order.card_payment_confirm.desc_next_allowance', {next: nextAvailableAllowanceToday}) : $t('order.card_payment_confirm.desc')"
        :cancel-label="$t('order.card_payment_confirm.discard', {total:  $options.filters.toCurrency( cart.calculation.price_sum_user, currency.locale, currency.currency_code )})"
        :confirm-label="$t('order.card_payment_confirm.accept')"
        cancel-icon="credit-card"
        confirm-icon="wallet"
        @confirm="cancelCardPayment"
        @cancel="placeOrder"
        hide-button)
</template>
